import { gql } from '@apollo/client';

export const PartnerBranchFragment = gql`
  fragment PartnerBranchFragment on PartnerBranch {
    branchId
    marketDisplayName
    marketActive
    regionIdentifier
    internalOrganizationId
    partnerIdentifier
  }
`;
